<div class="container">
  <div class="ultimateguide-head">
    <div class="head-left">
      <div class="content-head2">
        <h4 class="contentname marginunset _subheading" style="color: #2898cb">{{
          'ULTIMATEGUIDE.CONTENTNAME' | translate
        }}</h4>
      </div>
      <div class="content-head">
        <h4 class="contentname marginunset _subheading" style="color: #2898cb">{{
          'ULTIMATEGUIDE.CONTENTNAME' | translate
        }}</h4>
      </div>
      <h1 class="new-headtext marginunset _heading">{{ 'ULTIMATEGUIDE.HEADTEXT' | translate }}</h1>
      <div class="new-detailtext">
        <div style="padding-bottom: 10px">{{ 'ULTIMATEGUIDE.DETAILTEXT' | translate }}</div>
        <div>{{ 'ULTIMATEGUIDE.DETAILTEXT2' | translate }}</div>
      </div>

      <div class="wrapper-download">
        <a
          href="https://auth.flowaccount.com/{{ translate.currentLang }}/Account/Register"
          target="_blank"
          rel="nofollow"
          style="text-decoration: unset"
        >
          <div class="button-download">
            {{ 'ULTIMATEGUIDE.DOWNLOAD' | translate }}
          </div>
        </a>
      </div>
    </div>
    <div class="head-right">
      <picture>
        <source
          srcset="https://flowaccountcdn.com/new_landing/image/UltimateGuide/Ultimate_head_1_v2.webp"
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/UltimateGuide/Ultimate_head_1_v2.jpg"
          width="100%"
          alt="FlowAccount Ultimate Guide"
          loading="lazy"
        />
      </picture>
    </div>
  </div>

  <div class="ultimateguide-head sec2">
    <div class="head-left ipad">
      <h2 class="new-headtext marginunset _heading">{{ 'ULTIMATEGUIDE.HEADTEXT_2' | translate }}</h2>
      <div class="new-detailtext">{{ 'ULTIMATEGUIDE.DETAILTEXT_2' | translate }}</div>

      <a
        href="https://flowaccountcdn.com/new_landing/image/UltimateGuide/Comprehensive-users-manual-for-FlowAccount.pdf"
        target="_blank"
        rel="noopener noreferrer"
        class="link-app-line"
        class="link-app-line"
      >
        <span>{{ 'ULTIMATEGUIDE.DETAILTEXT_3_LINK' | translate }}</span
        ><i class="fa fa-angle-right right"></i>
      </a>
    </div>
    <div class="head-right">
      <picture>
        <source
          srcset="https://flowaccountcdn.com/new_landing/image/UltimateGuide/Ultimate_head_2_v2.webp"
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/UltimateGuide/Ultimate_head_2_v2.jpg"
          width="100%"
          alt="FlowAccount Ultimate Guide"
          loading="lazy"
        />
      </picture>
    </div>
    <div class="head-left">
      <h2 class="new-headtext marginunset _heading">{{ 'ULTIMATEGUIDE.HEADTEXT_2' | translate }}</h2>
      <div class="new-detailtext">{{ 'ULTIMATEGUIDE.DETAILTEXT_2' | translate }}</div>

      <a
        href="https://flowaccountcdn.com/new_landing/image/UltimateGuide/Comprehensive-users-manual-for-FlowAccount.pdf"
        target="_blank"
        rel="noopener noreferrer"
        class="link-app-line"
      >
        <span>{{ 'ULTIMATEGUIDE.DETAILTEXT_3_LINK' | translate }}</span
        ><i class="fa fa-angle-right right"></i>
      </a>
    </div>
  </div>

  <flowaccount-starter-kit-shared [styleClass]="'ultimateguide'"> </flowaccount-starter-kit-shared>

  <div class="freeregistor background-color-gray">
    <div class="container">
      <h2 class="new-headtext marginunset color_text">{{ 'ULTIMATEGUIDE.REGISTOR_3' | translate }} </h2>
      <div class="new-detail-content">{{ 'ULTIMATEGUIDE.DETAIL_3' | translate }}</div>
      <div class="box__btn">
        <a
          href="https://flowaccountcdn.com/new_landing/image/UltimateGuide/Comprehensive-users-manual-for-FlowAccount.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="box__btn--layout">{{ 'ULTIMATEGUIDE.BUTTON_FREE' | translate }}</div>
        </a>
      </div>
    </div>
  </div>

  <div class="ultimateguide-content-heading">
    <div class="content-head">{{ 'ULTIMATEGUIDE.GUIDE_HEAD' | translate }}</div>
    <div class="content-detail">{{ 'ULTIMATEGUIDE.GUIDE_DETAIL' | translate }}</div>
    <div class="list-content">
      <div class="list left">
        <!-- ultimate guide 1 -->
        <div>
          <div class="list-ultimate">{{ 'ULTIMATEGUIDE.CONTENT_HEAD_1' | translate }}</div>
          <div *ngFor="let y of ul1">
            <div class="clearfix">
              <div class="list-click">
                <a class="desktop" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title : y.title_en }}
                </a>
                <a class="mobile" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title_mobile : y.title_mobile_en }}
                </a>
              </div>
              <div class="list-min">{{ y.read }} {{ 'ULTIMATEGUIDE.MIN_READ' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="list">
        <!-- ultimate guide 2 -->
        <div>
          <div class="list-ultimate">{{ 'ULTIMATEGUIDE.CONTENT_HEAD_2' | translate }}</div>
          <div *ngFor="let y of ul2">
            <div class="clearfix">
              <div class="list-click">
                <a class="desktop" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title : y.title_en }}
                </a>
                <a class="mobile" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title_mobile : y.title_mobile_en }}
                </a>
              </div>
              <div class="list-min">{{ y.read }} {{ 'ULTIMATEGUIDE.MIN_READ' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-content">
      <div class="list left">
        <!-- ultimate guide 3 -->
        <div>
          <div class="list-ultimate">{{ 'ULTIMATEGUIDE.CONTENT_HEAD_3' | translate }}</div>
          <div *ngFor="let y of ul3">
            <div class="clearfix">
              <div class="list-click">
                <a class="desktop" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title : y.title_en }}
                </a>
                <a class="mobile" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title_mobile : y.title_mobile_en }}
                </a>
              </div>
              <div class="list-min">{{ y.read }} {{ 'ULTIMATEGUIDE.MIN_READ' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="list">
        <!-- ultimate guide 7 -->
        <div>
          <div class="list-ultimate">{{ 'ULTIMATEGUIDE.CONTENT_HEAD_7' | translate }}</div>
          <div *ngFor="let y of ul7">
            <div class="clearfix">
              <div class="list-click">
                <a class="desktop" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title : y.title_en }}
                </a>
                <a class="mobile" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title_mobile : y.title_mobile_en }}
                </a>
              </div>
              <div class="list-min">{{ y.read }} {{ 'ULTIMATEGUIDE.MIN_READ' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-content">
      <div class="list left">
        <!-- ultimate guide 4 -->
        <div>
          <div class="list-ultimate">{{ 'ULTIMATEGUIDE.CONTENT_HEAD_4' | translate }}</div>
          <div *ngFor="let y of ul4">
            <div class="clearfix">
              <div class="list-click">
                <a class="desktop" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title : y.title_en }}
                </a>
                <a class="mobile" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title_mobile : y.title_mobile_en }}
                </a>
              </div>
              <div class="list-min">{{ y.read }} {{ 'ULTIMATEGUIDE.MIN_READ' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="list">
        <!-- ultimate guide 5 -->
        <div>
          <div class="list-ultimate">{{ 'ULTIMATEGUIDE.CONTENT_HEAD_5' | translate }}</div>
          <div *ngFor="let y of ul5">
            <div class="clearfix">
              <div class="list-click">
                <a class="desktop" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title : y.title_en }}
                </a>
                <a class="mobile" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title_mobile : y.title_mobile_en }}
                </a>
              </div>
              <div class="list-min">{{ y.read }} {{ 'ULTIMATEGUIDE.MIN_READ' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-content">
      <div class="list left">
        <!-- ultimate guide 6 -->
        <div>
          <div class="list-ultimate">{{ 'ULTIMATEGUIDE.CONTENT_HEAD_6' | translate }}</div>
          <div *ngFor="let y of ul6">
            <div class="clearfix">
              <div class="list-click">
                <a class="desktop" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title : y.title_en }}
                </a>
                <a class="mobile" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title_mobile : y.title_mobile_en }}
                </a>
              </div>
              <div class="list-min">{{ y.read }} {{ 'ULTIMATEGUIDE.MIN_READ' | translate }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="list">
        <!-- ultimate guide 8 update 10/05/2021-->
        <div>
          <div class="list-ultimate">{{ 'ULTIMATEGUIDE.CONTENT_HEAD_8' | translate }}</div>
          <div *ngFor="let y of ul8">
            <div class="clearfix">
              <div class="list-click">
                <a class="desktop" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title : y.title_en }}
                </a>
                <a class="mobile" href="{{ translate.currentLang === 'th' ? y.link_th : y.link_en }}" target="_blank">
                  {{ translate.currentLang === 'th' ? y.title_mobile : y.title_mobile_en }}
                </a>
              </div>
              <div class="list-min">{{ y.read }} {{ 'ULTIMATEGUIDE.MIN_READ' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<flowaccount-content-call-to-action-squidex
  [contentCTA_1]="'CONTENT_CTA_SQUIDEX_ULTIMATEGUIDE.HEADING_1'"
  [contentCTA_2]="'CONTENT_CTA_SQUIDEX_ULTIMATEGUIDE.HEADING_2'"
  [contentTextLink]="'CONTENT_CTA_SQUIDEX_ULTIMATEGUIDE.BUTTON_LINK'"
  [contentScully]="'CONTENT_CTA_ULTIMATEGUIDE'"
  [styleClass]="'ultimateguide'"
></flowaccount-content-call-to-action-squidex>

<flowaccount-blog-swiper-squidex
  [customHeader]="customHeader"
  [lang]="translate.currentLang"
  [contentSquidex]="'ultimateguide-blog'"
  [contentScully]="'ultimateguide-blog-key'"
></flowaccount-blog-swiper-squidex>
